import { useEffect, useRef, useState } from "react";
import makeStyles from '@mui/styles/makeStyles';

//components
import Grid from "@mui/material/Grid";
import UniversalControler from "components/universalControler";
import RecController from "components/RecController";

//assets
// import TLButtonOut from "assets/phase4/TL_out.png";
// import TLButtonIn from "assets/phase4/TL_in.png";

// import TLButtonOut from "assets/phase5/TL_out.png";
// import TLButtonIn from "assets/phase5/TL_in.png";
import TLButtonOut from "assets/phase8/TL_out.png";
import TLButtonIn from "assets/phase8/TL_in.png";

import DefaultButtonOut from "assets/phase7/Default_out.png";
import DefaultButtonIn from "assets/phase7/Default_in.png";
import DelButton from "assets/phase7/Del_out.png";
import SaveButtonOut from "assets/phase7/Save_out.png";
import SaveButtonIn from "assets/phase7/Save_in.png";
import ShareButtonIn from "assets/phase7/Share_in.png";
import ShareButtonOut from "assets/phase7/Share_out.png";
import SCRButton from "assets/phase7/SCR_out.png";
import RecButtonIn from "assets/phase5/Rec_in.png";
import RecButtonOut from "assets/phase5/Rec_out.png";

import blankAlbumArtRightPart from "assets/phase4/TopRightBlank.png";

//providers
import { useTimelineState } from "providers/TimelineProvider";
import { usePreferenceState } from "providers/PreferenceProvider";

//hooks
import { useSubmitPreferences } from "hooks/preference";

//helpser
import { isEmpty } from "lodash";

const backgroundGeneralStates = {
  backgroundSize: "100% auto",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
};

const useStyles = makeStyles((theme) => ({
  topDotDisplay: {
    width: "100%",
    height: "12%",
    paddingRight: "27%",
  },
  controlers: {
    width: "100%",
    position: "relative",
    height: "59%",
  },

  bottomBox: {
    width: "100%",
    height: "29%",
  },
  TLBtn: {
    height: "90%",
    // aspectRatio: "300/105",
    top: "5%",
    position: "relative",
    // left: "10%",
    ...backgroundGeneralStates,
  },
  rightBtn: {
    width: "100%",
    // height: "100%",
    // aspectRatio:'fixed',
    // aspectRatio: "300/109",
    top: "5%",
    position: "relative",
    // left: "-5%",
    // marginBottom: "28%",
    ...backgroundGeneralStates,
  },
  leftBtn: {
    width: "100%",
    // height: "100%",
    // aspectRatio:'fixed',
    // aspectRatio: "300/109",
    top: "5%",
    position: "relative",
    left: "-5%",
    marginBottom: "28%",
    ...backgroundGeneralStates,
  },
  DefaultBtn: {
    width: "90%",
    // height: "100%",
    // aspectRatio:'fixed',
    // aspectRatio: "300/109",
    top: "5%",
    position: "relative",
    left: "-5%",
    ...backgroundGeneralStates,
  },

  ShareBtn: {
    width: "89%",
    // height: "100%",
    // aspectRatio:'fixed',
    aspectRatio: "300/109",
    top: "10%",
    position: "relative",
    left: "-9%",
    ...backgroundGeneralStates,
  },
  downBtns: {
    // width: "88%",
    height: "88%",
    // height: "50%",
    // aspectRatio: "300/181",
    position: "relative",
    ...backgroundGeneralStates,
    backgroundSize: "auto 100%",
  },

  RecButton: {
    width: "90%",
    aspectRatio: "300/73",

    // height: "50%",
    ...backgroundGeneralStates,
  },
}));

function MiddleContainer({
  percentOfHeight,
  percentOfWidth,
  currentTime,
  currentTrack,
  audioContextInstance,
  mergerNode,
  webAudioOutput,
  setCurrentTime,
  announceCurrentPortion,
  portrait,
  tempoRotateDirection,
  tempo,
  playState,
  setPlayState,
  bringBackTheMasterVolume,
  stopPropagate,
  setTimestamps,
}) {
  const classes = useStyles();

  const [timeline, setTimeline] = useTimelineState();
  const [preferences, setPreferences] = usePreferenceState();

  const { mutate: submitPreferences, isLoading: isSubmittingPreferences } =
    useSubmitPreferences();

  const [lastTempo, setLastTempo] = useState(tempo);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [trackStates, setTrackStates] = useState({});
  const [pressingTLButton, setPressingTLButton] = useState(false);
  const [pressingDefaultButton, setPressingDefaultButton] = useState(false);
  const [pressingShareButton, setPressingShareButton] = useState(false);
  const [pressingRecButton, setPressingRecButton] = useState(false);

  const [layers, setLayers] = useState({
    layer1: {
      id: "layer1",
      type: "vocal",
      name: "vocmel",
      layerNumber: 0,
      layerPosition: 0,
      isDecorative: true,
      selected: true,
    },
    layer2: {
      id: "layer2",
      name: "drum",
      layerNumber: 1,
      layerPosition: 2,
      isDecorative: true,
    },
    layer3: {
      id: "layer3",
      name: "inst",
      layerNumber: 2,
      layerPosition: 4,
      isDecorative: true,
    },
    layer4: {
      id: "layer4",
      name: "altvoc",
      layerNumber: 3,
      layerPosition: 1,
      isDecorative: true,
    },
    layer5: {
      id: "base",
      name: "base",
      layerNumber: 4,
      layerPosition: 3,
      isDecorative: true,
    },
  });
  const referencePool = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const getMinimumCurrentTime = () => {
    let minimumCurrentTime = Infinity;
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      if (minimumCurrentTime > layer.ref.current.audioElement.currentTime) {
        minimumCurrentTime = layer.ref.current.audioElement.currentTime;
      }
    }
    return minimumCurrentTime;
  };

  const changeState = (name, newState) => {
    // console.log(
    //   name,
    //   " has fired a",
    //   newState,
    //   "and playstate is: ",
    //   playState
    // );
    if (trackStates[name] === newState || newState === playState) return;
    // console.log(
    //   name,
    //   " has fired a",
    //   newState,
    //   "and playstate is: ",
    //   playState
    // );
    let newTrackStates = { ...trackStates };
    // setTrackStates({...trackStates,[name]:newState});
    newTrackStates[name] = newState;

    if (newState === "waiting" && playState === "played") {
      // console.log("****************");
      setPlayState("waiting", true);
      let minimumCurrentTime = getMinimumCurrentTime();
      for (let layer of Object.values(layers)) {
        if (layer.isDecorative) continue;

        // if (layer.name !== name) {
        //   newTrackStates[layer.name] = "readyToPlay";
        //   // console.log()
        // }
        // layer.ref.current.audioElement.currentTime = minimumCurrentTime;
      }
    }

    //check states
    let trackStateValues = Object.values(newTrackStates);
    if (trackStateValues.every((element) => element == "readyToPlay")) {
      if (playState === "waiting") {
        // handelPlay();
        setPlayState("played", true);
      }
      if (playState === "seeked") {
        for (let layer of Object.values(layers)) {
          if (layer.isDecorative) continue;
          layer.ref.current.play();
        }
        // bringBackTheMasterVolume();
        setPlayState("played", true);
      }
    }
    // if (trackStateValues.every((element) => element == "ended")) {
    //   console.log("all has been ended");
    //   this.handelNextTrack();
    //   this.announceCurrentPortion(0);
    // }
    setTrackStates(newTrackStates);
  };

  const handelPlay = () => {
    let minimumCurrentTime = getMinimumCurrentTime();
    changeCurrentTimeHandler(minimumCurrentTime);
    audioContextInstance.resume();
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      // console.log(layer.ref)
      // layer.ref.current.audioContext.resume();
      layer.ref.current.audioElement.play();
    }
  };

  const handelPause = () => {
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      layer.ref.current.audioElement.pause();
    }
  };

  const changeCurrentTimeHandler = (time) => {
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      if (layer.ref.current.audioElement.currentTime !== time) {
        layer.ref.current.audioElement.currentTime = time;
      }
      // layer.ref.current.audioElement.currentTime = time;
    }
  };

  const preferenceChangeHandler = (
    bareNumber,
    layerId,
    preferenceKey,
    PreferenceValue
  ) => {
    if (Object.keys(preferences).length == 0) return;
    let newPreferences = { ...preferences };
    if (!newPreferences["bares"][bareNumber]) {
      newPreferences["bares"][bareNumber] = {};
    }
    if (!newPreferences["bares"][bareNumber][layerId]) {
      newPreferences["bares"][bareNumber][layerId] = {};
    }
    newPreferences["bares"][bareNumber][layerId][preferenceKey] =
      PreferenceValue;
    setPreferences(newPreferences);
  };

  const handelTempoChange = (newValue) => {
    const ratio = newValue / (lastTempo + 0.0);
    const newSpeed = playbackSpeed * ratio;

    for (let layer of Object.values(layers)) {
      if (layer?.ref?.current?.isDecorative) continue;
      if (isNaN(newSpeed)) {
        continue;
      }
      layer?.ref?.current?.changePlaybackSpeed(newSpeed);
    }
    setLastTempo(newValue);
    setPlaybackSpeed(playbackSpeed * ratio);
  };

  useEffect(() => {
    handelTempoChange(tempo);
  }, [tempo]);

  useEffect(() => {
    if (playState === "seeked") {
      changeCurrentTimeHandler(currentTime);
      bringBackTheMasterVolume();
    }
  }, [bringBackTheMasterVolume, changeCurrentTimeHandler, currentTime, playState]);

  useEffect(() => {
    if (stopPropagate) return;
    if (playState === "played") {
      handelPlay();
    } else if (playState === "paused") {
      handelPause();
    }
  }, [handelPause, handelPlay, playState, stopPropagate]);
  // useEffect(() => {
  //   console.log(playState)
  // }, [playState])

  useEffect(() => {
    if (timeline && timeline.timestamps) {
      setTimestamps(timeline.timestamps);
      setLastTempo(timeline.defaultTempo);
    }
    if (timeline && timeline.layers && preferences && preferences.bares) {
      // let bareNumber = currentTrack + 1;
      let bareNumber = Math.max(currentTrack, 1);

      let currentBareConfigs = preferences.bares[bareNumber];
      let referenceIndex = 0;
      let newLayerConfigs = { ...timeline.layers };
      for (let layerId of Object.keys(newLayerConfigs)) {
        newLayerConfigs[layerId].ref = referencePool[referenceIndex++];
        // newLayerConfigs[layerId].ledRef = useRef(null);
        newLayerConfigs[layerId].volume =
          currentBareConfigs[layerId]?.volume || 1;
        newLayerConfigs[layerId].panning =
          currentBareConfigs[layerId]?.panning || 0;
        newLayerConfigs[layerId].reverb1 =
          currentBareConfigs[layerId]?.reverb1 || 0;
        newLayerConfigs[layerId].reverb2 =
          currentBareConfigs[layerId]?.reverb2 || 0;
        newLayerConfigs[layerId].eq1 = currentBareConfigs[layerId]?.eq1 || 1;
        newLayerConfigs[layerId].eq2 = currentBareConfigs[layerId]?.eq2 || 1;
        newLayerConfigs[layerId].eq3 = currentBareConfigs[layerId]?.eq3 || 1;
        newLayerConfigs[layerId].flanger =
          currentBareConfigs[layerId]?.flanger || 0;
        newLayerConfigs[layerId].robot =
          currentBareConfigs[layerId]?.robot || 0;
        newLayerConfigs[layerId].phone =
          currentBareConfigs[layerId]?.phone || 0;
        newLayerConfigs[layerId].state =
          currentBareConfigs[layerId]?.state || "normal";
      }

      setLayers(newLayerConfigs);
    }
  }, [timeline, preferences]);

  useEffect(() => {
    if (!currentTrack || !preferences || !preferences.bares) return;
    let bareNumber = Math.max(currentTrack, 1);
    let currentBareConfigs = preferences.bares[bareNumber] || {};
    let newLayerConfigs = { ...layers };
    for (let layerId of Object.keys(newLayerConfigs)) {
      newLayerConfigs[layerId].volume =
        currentBareConfigs[layerId]?.volume || 1;
      newLayerConfigs[layerId].panning =
        currentBareConfigs[layerId]?.panning || 0;
      newLayerConfigs[layerId].reverb1 =
        currentBareConfigs[layerId]?.reverb1 || 0;
      newLayerConfigs[layerId].reverb2 =
        currentBareConfigs[layerId]?.reverb2 || 0;
      newLayerConfigs[layerId].eq1 = currentBareConfigs[layerId]?.eq1 || 1;
      newLayerConfigs[layerId].eq2 = currentBareConfigs[layerId]?.eq2 || 1;
      newLayerConfigs[layerId].eq3 = currentBareConfigs[layerId]?.eq3 || 1;
      newLayerConfigs[layerId].flanger =
        currentBareConfigs[layerId]?.flanger || 0;
      newLayerConfigs[layerId].robot = currentBareConfigs[layerId]?.robot || 0;
      newLayerConfigs[layerId].phone = currentBareConfigs[layerId]?.phone || 0;
      newLayerConfigs[layerId].state =
        currentBareConfigs[layerId]?.state || "normal";
    }
    setLayers(newLayerConfigs);
  }, [currentTrack, preferences]);

  const handelSelection = (selectedLayerId) => {
    for (let layer of Object.values(layers)) {
      if (layer?.ref?.current?.isDecorative) continue;
      if (layer.name !== selectedLayerId) layer?.ref?.current?.deselect();
    }
  };

  const handelSoloSideEffects = (targetLayerName) => {
    for (let layerName of Object.keys(layers)) {
      if (layerName !== targetLayerName && !layers[layerName].isDecorative)
        layers[layerName].ref.current.setMute(true);
    }
  };

  return (
    <>
      <Grid item container direction="row" className={classes.topDotDisplay}>
        <Grid
          item
          xs={12}
          style={{ height: "100%", position: "relative" }}
        >
          <img
            src={
              timeline?.rightAlbumArtUrl
                ? timeline?.rightAlbumArtUrl
                : blankAlbumArtRightPart
            }
            // src={albumArtRightPart}
            style={{
              width: "100%",
              // right: "0.35%",
              // top: "2%",
              position: "absolute",
            }}
          ></img>
        </Grid>
      </Grid>

      <Grid
        item
        container
        className={classes.controlers}
        style={{ display: "grid" }}
      >
        {Object.keys(layers).map((layerId) => {
          return (
            <UniversalControler
              playbackSpeed={playbackSpeed}
              layerId={layers[layerId]?.id}
              layerNumber={layers[layerId]?.layerNumber}
              layerPosition={layers[layerId]?.layerPosition}
              mergerNodeReference={mergerNode}
              audioContextInstance={audioContextInstance}
              ref={layers[layerId]?.ref}
              key={layers[layerId]?.name}
              name={layers[layerId]?.name}
              initialVolume={layers[layerId]?.volume || 1}
              initialPanning={layers[layerId]?.panning || 0}
              initialReverb1={layers[layerId]?.reverb1 || 0}
              initialReverb2={layers[layerId]?.reverb2 || 0}
              initialEQ1={layers[layerId]?.eq1 || 1}
              initialEQ2={layers[layerId]?.eq2 || 1}
              initialEQ3={layers[layerId]?.eq3 || 1}
              initialFlanger={layers[layerId]?.flanger || 0}
              initialRobot={layers[layerId]?.robot || 0}
              initialPhone={layers[layerId]?.phone || 0}
              portrait={portrait}
              preferenceChangeHandler={preferenceChangeHandler}
              src={layers[layerId].url}
              initialMuted={layers[layerId]?.state === "muted"}
              initialSolo={layers[layerId]?.state === "solo"}
              soloSideEffectFunction={handelSoloSideEffects}
              announceCurrentPortion={announceCurrentPortion}
              announcCurrenttime={setCurrentTime}
              stateChanger={changeState}
              currentTrackNumber={currentTrack}
              handelSelectionFunction={handelSelection}
              audioDestination={webAudioOutput}
              isDecorative={layers[layerId]?.isDecorative && true}
              selected={layers[layerId].selected}
              percentOfHeight={percentOfHeight}
              percentOfWidth={percentOfWidth}
              currentTime={currentTime}
            ></UniversalControler>
          );
        })}
      </Grid>

      <Grid item className={classes.bottomBox}>
        <Grid
          container
          direction="row"
          style={{ height: "100%", paddingRight: "2%" }}
        >
          <Grid
            item
            xs={3}
            style={{ height: "100%", paddingLeft: "1%" }}
          >
            <Grid container direction="row" style={{ height: "100%" }}>
              <Grid item xs={8}>
                <RecController
                  playbackSpeed={playbackSpeed}
                  layerId="drums"
                  audioContextInstance={audioContextInstance}
                  name={"drums"}
                  // initialVolume={layers[layerId]?.volume || 1}
                  // initialPanning={layers[layerId]?.panning || 0}
                  // initialReverb1={layers[layerId]?.reverb1 || 0}
                  // initialReverb2={layers[layerId]?.reverb2 || 0}
                  // initialEQ1={layers[layerId]?.eq1 || 1}
                  // initialEQ2={layers[layerId]?.eq2 || 1}
                  // initialEQ3={layers[layerId]?.eq3 || 1}
                  // initialFlanger={layers[layerId]?.flanger || 0}
                  // initialRobot={layers[layerId]?.robot || 0}
                  // initialPhone={layers[layerId]?.phone || 0}
                  // portrait={portrait}
                  preferenceChangeHandler={preferenceChangeHandler}
                  // selected
                  isDecorative={true}
                  percentOfHeight={percentOfHeight}
                  percentOfWidth={percentOfWidth}
                ></RecController>
              </Grid>
              <Grid item xs={4}>
                <Grid
                  container
                  direction="column"
                  style={{
                    height: "100%",
                    width: "100%",
                    paddingBottom: "20%",
                  }}
                >
                  <Grid item xs={4}>
                    <div
                      className={classes.leftBtn}
                      style={{
                        backgroundImage: `url(${DelButton})`,
                        height: "100%",
                      }}
                      // onMouseDown={() => setPressingDefaultButton(true)}
                      // onMouseUp={() => setPressingDefaultButton(false)}
                      // onMouseLeave={() => setPressingDefaultButton(false)}
                      // onClick={this.resetEffects}
                    >
                      &nbsp;
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div
                      className={classes.leftBtn}
                      style={{
                        backgroundImage: `url(${SCRButton}`,
                        height: "100%",
                        // left: "-9%",
                      }}
                      // onMouseDown={() => setPressingDefaultButton(true)}
                      // onMouseUp={() => setPressingDefaultButton(false)}
                      // onMouseLeave={() => setPressingDefaultButton(false)}
                      // onClick={this.resetEffects}
                    >
                      &nbsp;
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div
                      className={classes.leftBtn}
                      style={{
                        backgroundImage: `url(${SaveButtonOut}`,
                        height: "100%",
                        // left: "-9%",
                      }}
                      // onMouseDown={() => setPressingDefaultButton(true)}
                      // onMouseUp={() => setPressingDefaultButton(false)}
                      // onMouseLeave={() => setPressingDefaultButton(false)}
                      // onClick={this.resetEffects}
                    >
                      &nbsp;
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} style={{ height: "100%" }}>
            &nbsp;
          </Grid>
          <Grid item xs={3} style={{ paddingLeft: "3.75%" }}>
            <Grid
              container
              direction="column"
              // alignItems="center"
              // justifyContent="center"
              style={{ height: "100%", width: "100%" }}
            >
              <Grid item xs={6} style={{ height: "50%" }}>
                <div
                  className={classes.TLBtn}
                  style={{
                    backgroundImage: `url(${
                      pressingTLButton ? TLButtonIn : TLButtonOut
                    })`,
                  }}
                  onClick={() => {
                    if (isEmpty(preferences)) return;

                    submitPreferences(
                      {
                        preferences: {
                          timelineId: preferences.timelineId,
                          bares: preferences.bares,
                          repeats: preferences.repeats,
                          sequence: preferences.sequence,
                        },
                      },
                      {
                        onSuccess: (response) => {
                          if (response && response.status === "OK") {
                          }
                        },
                      }
                    );
                  }}
                  onMouseDown={() => setPressingTLButton(true)}
                  onMouseUp={() => setPressingTLButton(false)}
                  onMouseLeave={() => setPressingTLButton(false)}
                >
                  &nbsp;
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                style={{ width: "100%" }}
              >
                <Grid
                  container
                  direction="row"
                  spacing={0}
                  style={{
                    height: "100%",
                    width: "100%",
                    
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    style={{ height: "33.33%" }}
                  >
                    <Grid
                      container
                      direction="row"
                      style={{
                        // height: "100%",
                        // top: "5%",
                        // alignItems: "center",
                        
                      }}
                    >
                      <Grid item xs={6}>
                        <div
                          className={classes.rightBtn}
                          style={{
                            backgroundImage: `url(${
                              pressingDefaultButton
                                ? DefaultButtonIn
                                : DefaultButtonOut
                            })`,
                          }}
                          onMouseDown={() => setPressingDefaultButton(true)}
                          onMouseUp={() => setPressingDefaultButton(false)}
                          onMouseLeave={() => setPressingDefaultButton(false)}
                          // onClick={this.resetEffects}
                        >
                          &nbsp;
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div
                          className={classes.rightBtn}
                          style={{
                            backgroundImage: `url(${
                              pressingShareButton
                                ? ShareButtonIn
                                : ShareButtonOut
                            })`,
                          }}
                          onMouseDown={() => setPressingShareButton(true)}
                          onMouseUp={() => setPressingShareButton(false)}
                          onMouseLeave={() => setPressingShareButton(false)}
                          // onClick={this.resetEffects}
                        >
                          &nbsp;
                        </div>
                      </Grid>
                    </Grid>

                    
                  </Grid>
                  <Grid
                      item
                      xs={12}
                      style={{ height: "66.66%" }}
                    >
                      
                    </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid container direction="column" style={{ height: "100%" }}>
              <Grid item xs={5} style={{ height: "100%" }}>
                <Grid container direction="row" style={{ height: "100%" }}>
                  <Grid item xs={12}></Grid>
                  <Grid item xs={6}>
                    
                  </Grid>

                  <Grid item xs={6}>
                    
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} style={{ height: "100%" }}>
                &nbsp;
              </Grid>
              <Grid item xs={4} style={{ height: "100%" }}>
                <Grid
                  container
                  direction="row"
                  columns={12}
                  style={{ height: "100%" }}
                >
                  <Grid item xs={12}>
                    
                  </Grid>

                  <Grid item xs={4}>
                    
                  </Grid>

                  <Grid item xs={4}>
                    
                  </Grid>

                  <Grid item xs={4}>
                    
                  </Grid>
                </Grid>
              </Grid>

              
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default MiddleContainer;
